
import { useAdminConnection } from '@/hooks/useAdminConnection';
import { ConnectionStatusStrict } from '@/hooks/useConnectionState';

/**
 * Hook for managing admin mode (Always in Production mode)
 */
export const useAdminPageMode = () => {
  // Use the connection hook
  const { connectionStatus, checkConnection } = useAdminConnection();
  
  // Always in production mode
  const isProduction = true;
  const isChangingMode = false;
  const toggleMode = async () => true; // No-op function that just returns true
  
  return {
    isProduction,
    toggleMode,
    isChangingMode,
    connectionStatus: connectionStatus as ConnectionStatusStrict,
    checkConnection
  };
};
